<script>
import NavigationHeader from '../NavigationHeader.vue';
import ButtonIconLeft from '../buttons/ButtonIconLeft.vue';
import Modal from '../shared/Modal.vue';

import UserService from '@/services/UserService';
import SorterService from '@/services/SorterService';
import FaxUserService from '@/services/FaxUserService';
import SupportUserService from '@/services/SupportUserService';

export default {
    name: 'UserOverview',
    components: {
        NavigationHeader,
        ButtonIconLeft,
        Modal,
    },
    data() {
        return {
            userList: [],
            isModalForUserLimitVisible: false,
            blockAddingOfUsersBecauseOfUserLimit: false,
        };
    },
    created() {
        UserService.getAllUsers().then(response => {
            this.userList = response.data;
            FaxUserService._removeFaxUserFromList(this.userList);
            SupportUserService._removeSupportUserFromList(this.userList);
            SorterService._sortArrayOfStringsByParam(
                this.userList,
                'familyName'
            );
            if (this.userList.length === 10) {
                this.blockAddingOfUsersBecauseOfUserLimit = true;
            }
        });
    },
    methods: {
        addUser() {
            if (this.blockAddingOfUsersBecauseOfUserLimit) {
                this.isModalForUserLimitVisible = true;
            } else {
                this.$router.push('/users/newUser');
            }
        },
        closeModalForUserLimit() {
            this.isModalForUserLimitVisible = false;
        },
    },
    computed: {
        countUsers() {
            let userCount = 0;
            for (const user of this.userList) {
                userCount++;
            }
            return userCount;
        }
    }
};
</script>

<template>
<div class="container">
    <div id="user-overview">
        <NavigationHeader route="/" navigationText="zurück zum Dashboard" title="Benutzerübersicht"/>
        <ButtonIconLeft @onClick="addUser" class="btn-add" buttonTitle="Benutzer hinzufügen"  src="add" cssClass="btn btn-primary"/>
        <table>
            <tr>
                <th>Nachname</th>
                <th>Vorname</th>
                <th>Login-ID</th>
                <th></th>
            </tr>
            <tr v-for="entry in userList" :key="entry.id">
                <td class="family-name">{{entry.familyName}}</td>
                <td>{{entry.firstName}}</td>
                <td>{{entry.login}}</td>
                <td><ButtonIconLeft class="btn-edit" @onClick="$router.push('/users/' + entry.id)" buttonTitle="bearbeiten" src="edit" cssClass="btn btn-tertiary"/></td>
            </tr>
        </table>

        <div class="utilized-users">
            <span>Verwendete Benutzer: {{countUsers}}/10</span>
        </div>
    </div>
    <Modal v-show="isModalForUserLimitVisible" :isFooter="false" :isCross="true" :isRed="true" @close="closeModalForUserLimit">
            <template slot="body">
                <div class="reached-user-limit">
                    <p>Du hast die maximale Anzahl von 10 Benutzern erreicht. Natürlich geht mit STARFACE noch mehr!
                        Wenn Du mehr Benutzer einrichten möchtest und die ganze Funktionsvielfalt von STARFACE-Telefonanlagen kennen lernen möchtest,
                        dann kontaktiere uns einfach!
                    </p>
                    <p>
                        <a href="tel:+49 721 981 991 00">
                            <img src="@/assets/starface_icons_png/16/orange/phone_16.png" alt="Call" />
                            <b>+49 721 981 991 00</b> anrufen
                        </a>
                    </p>
                    <p>
                        <a href="mailto:up@starface.com">
                            <img src="@/assets/starface_icons_png/16/orange/mail_16.png" alt="Write" />
                            <b>up@starface.com</b> schreiben
                        </a>
                    </p>
                </div>
            </template>
        </Modal>
</div>
</template>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
@import '../../assets/scss/buttons.scss';

#user-overview {
    .reached-user-limit {
        a {
            color: $orange;
            display: flex;
            align-items: center;
            img {
                margin-right: 15px;
            }
            b {
                padding-right: 8px;
            }
        }
    }
    .btn-add {
        float: right;
    }
    table {
        grid-row: 2;
        justify-self: start;
        text-align: left;
        border-spacing: 0;
        padding: 16px 0;
        width: 100%;
        font-size: 18px;
        tr {
            height: 48px;
            &:nth-child(odd) {
                background-color: white;
            }
        }
        th {
            color: white;
            font-weight: bold;
            background-color: $th-background-color;
            padding: 6px 16px;
            text-align: left;
        }
        td {
            padding: 6px 16px;
            .family-name {
                font-weight: bold;
            }
        }
        .btn-edit {
            float: right;
        }
        .family-name {
            font-weight: bold;
        }
    }
    .utilized-users {
        float: right;
        color: $grey-dark;
        font-size: 18px;
    }
}
.reached-user-limit {
    width: 864px;
    a {
        color: $orange;
        display: flex;
        align-items: center;
        img {
            margin-right: 15px;
        }
        b {
            padding-right: 8px;
        }
    }
}
</style>
